import tripHub from './trip-hub/index.vue'
import yourInformation from './trip-hub/your-information/index.vue'
import essentials from './trip-hub/essentials/index.vue'
import flights from './trip-hub/flights/index.vue'
import baggage from './trip-hub/flights/baggage/index.vue'
import onTheGround from './trip-hub/on-the-ground/index.vue'
import productPage from './trip-hub/product-page'
import otherServices from './trip-hub/other-services/index.vue'
import voucherDocuments from './vouchers-documents/index.vue'
import paymentBookingConditions from './payment-hub/index.vue'
import communications from './communications/index.vue'

export default [
  // Trip Hub
  {
    path: '/trip-hub',
    name: 'trip-hub-landing',
    component: tripHub,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
          },
        ]
      },
    },
  },
  {
    path: '/trip-hub/:bookingNumber/:surname',
    name: 'triphubauth',
    component: tripHub,
    meta: {
      requiresAuth: false,
      breadCrumb() {
        return [
          {
            text: "ViewTrail Home",
            to: { name: "landing" },
          },
          {
            text: "Trip Hub",
          },
        ];
      },
    },
  },
  // Trip Hub with auth
  {
    path: "/trip-hub/:bookingNumber/:surname/:source",
    name: "triphubauthsource",
    component: tripHub,
    meta: {
      requiresAuth: false,
      breadCrumb() {
        return [
          {
            text: "ViewTrail Home",
            to: { name: "landing" },
          },
          {
            text: "Trip Hub",
          },
        ];
      },
    },
  },
  //  ** Your Information
  {
    path: '/trip-hub/your-information',
    name: 'your-information-landing',
    component: yourInformation,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Your Information',
          },
        ]
      },
    },
  },
  //  ** Essentials
  {
    path: '/trip-hub/essentials',
    name: 'essentials-landing',
    component: essentials,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Essentials',
          },
        ]
      },
    },
  },
  {
    path: '/trip-hub/essentials/:bookingNumber/:surname/:source',
    name: 'essentialsAuth',
    component: essentials,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
    meta: {
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Essentials',
          },
        ]
      },
    },
  },
  //  ** Flights
  {
    path: '/trip-hub/flights',
    name: 'flights-landing',
    component: flights,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Flights',
          },
        ]
      },
    },
  },
  {
    path: '/trip-hub/flights/:bookingNumber/:surname/:source',
    name: 'flightsAuth',
    component: flights,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
    meta: {
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Flights',
          },
        ]
      },
    },
  },
  //  ** Flights - Baggage
  {
    path: '/trip-hub/flights/baggage',
    name: 'baggage-landing',
    component: baggage,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Flights',
            to: {
              name: 'flights-landing',
              params: {
                tripHub: 'Flights',
              },
            },
          },
          {
            text: 'Baggage',
          },
        ]
      },
    },
  },
  {
    path: '/trip-hub/flights/baggage/:bookingNumber/:surname/:source',
    name: 'baggageAuth',
    component: baggage,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
    meta: {
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Flights',
            to: {
              name: 'flights-landing',
              params: {
                tripHub: 'Flights',
              },
            },
          },
          {
            text: 'Baggage',
          },
        ]
      },
    },
  },
  //  ** On The Ground
  {
    path: '/trip-hub/on-the-ground',
    name: 'on-the-ground-landing',
    component: onTheGround,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'On the Ground',
          },
        ]
      },
    },
  },
  //  Action Required Emails use below EXT route
  {
    path: '/trip-hub/on-the-ground/:bookingNumber/:surname/:source',
    name: 'on-the-ground-landing',
    component: onTheGround,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'On the Ground',
          },
        ]
      },
    },
  },
  {
    path: '/trip-hub/on-the-ground/essential-info/:id',
    name: 'on-the-ground-product',
    component: productPage,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'On The Ground',
            to: {
              name: 'on-the-ground-landing',
              params: {
                onTheGround: 'On the Ground',
              },
            },
          },
          {
            text: 'Essential Info',
          },
        ]
      },
    },
  },
  //  ** Other Services
  {
    path: '/trip-hub/other-services',
    name: 'other-services-landing',
    component: otherServices,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Trip Hub',
            to: {
              name: 'trip-hub-landing',
              params: {
                tripHub: 'Trip Hub',
              },
            },
          },
          {
            text: 'Other Services',
          },
        ]
      },
    },
  },
  // Vouchers & Documents
  {
    path: '/vouchers-documents',
    name: 'vouchers-documents-landing',
    component: voucherDocuments,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Vouchers & Documents',
          },
        ]
      },
    },
  },
  {
    path: '/vouchers-documents/:bookingNumber/:surname/:source',
    name: 'vouchersAuth',
    component: voucherDocuments,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
    meta: {
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Vouchers & Documents',
          },
        ]
      },
    },
  },
  // Payment Hub
  {
    path: '/payment-hub',
    name: 'payment-hub-landing',
    component: paymentBookingConditions,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Payment Hub',
          },
        ]
      },
    },
  },
  // Payment Hub with auth
  {
    path: '/payment-hub/:bookingNumber/:surname/:source',
    name: 'payment-hub-landing-auth',
    component: paymentBookingConditions,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
    meta: {
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Payment Hub',
          },
        ]
      },
    },
  },
  // Communications
  {
    path: '/communications',
    name: 'communications',
    component: communications,
    meta: {
      requiresAuth: true,
      breadCrumb() {
        return [
          {
            text: 'ViewTrail Home',
            to: { name: 'landing' },
          },
          {
            text: 'Communications',
          },
        ]
      },
    },
  },
]
